import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useFetch } from './api';

const TYPES = ['wms', 'cart', 'carrier', 'erp'];

function Integrations() {
  const [integrationsByType, setIntegrationsByType] = useState({});
  const [actionsByType, setActionsByType] = useState({});
  const [loading, setLoading] = useState(true);
  const trackstar = useFetch();

  useEffect(() => {
    const hiddenActions = [
      'create_inventory_item', 'update_inventory_item',
      'create_kit', 'update_kit', 'create_receipt',
      'create_warehouse', 'update_warehouse',
    ];
    Promise.all([
      trackstar('internal/integrations'),
      // Resolve each type's actions independently so a missing/malformed
      // endpoint (e.g. erp, which the backend may not implement yet) yields
      // an empty list instead of rejecting the whole batch.
      ...TYPES.map((type) => trackstar(`internal/${type}/available-actions`)
        .then((data) => (Array.isArray(data?.actions) ? data.actions : []))
        .catch(() => [])),
    ]).then((results) => {
      const allIntegrations = results[0] || {};
      const integrations = {};
      const actions = {};
      TYPES.forEach((type, i) => {
        integrations[type] = (allIntegrations[type] || [])
          .filter((int) => int.integration_name !== 'sandbox')
          .sort((a, b) => a.display_name.localeCompare(b.display_name));
        actions[type] = results[i + 1]
          .filter((action) => !hiddenActions.includes(action));
      });
      setIntegrationsByType(integrations);
      setActionsByType(actions);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  return (
    <div className="page-container">
      <Outlet context={{ integrationsByType, actionsByType, loading }} />
    </div>
  );
}

export default Integrations;
